import React from 'react'
import { Route } from 'react-router-dom'
import { ERROR } from 'core/routing/constants'
import ErrorPage from '.'

const router = <Route exact path={ERROR} component={ErrorPage} />

export default router
